<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Банеры</strong>
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <BannersTable
                            class="mt-4"
                            :data.sync="data"
                            @select="(id) => $router.push(`banners/${id}`)"
                        />
                    </template>
                </CCardBody>

                <CCardFooter>
                    <div class="d-flex justify-content-between">
                        <CButton
                            color="primary"
                            class="mr-3"
                            @click="$router.push(`banners/create`)"
                        >Создать</CButton
                        >
                        <CButton
                            class="ml-4"
                            color="info"
                            @click="reorder"
                        >Сохранить расположение</CButton>
                    </div>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import BannersTable from '@/components/banners/BannersTable';

    export default {
        name: 'BannersList',

        components: {
            BannersTable,
        },

        data() {
            return {
                loading: true,
                data: [],
            };
        },

        async created() {
            await Promise.all([this.fetchList()]);
            this.loading = false;
        },

        methods: {
            async fetchList() {
                const response = await this.axios.get('/banners');
                this.data = response.data;

            },
            async reorder() {
                try {
                    const payload = {
                        reorder: this.data.map((item, idx) => ({ id: item.id, position: idx + 1, title: item.title }))
                    };
                    await this.axios.post('/banners/reorder', payload);
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка сохранения расположения.');
                }
            }
        },
    };
</script>
